import React, { ReactNode } from 'react';

import styles from './detailBox.scss';

interface Props {
  children: ReactNode | ReactNode[];
  showLeftBorder?: boolean;
  shadow?: boolean;
  hasError?: boolean;
}

const DetailBox: React.FC<Props> = ({ children, showLeftBorder = false, shadow = false, hasError = false }) => {
  return (
    <div
      className={`${styles.box} ${showLeftBorder ? styles.leftBorder : ''} ${shadow ? styles.shadow : ''} ${
        hasError ? styles.error : ''
      }`}
    >
      {children}
    </div>
  );
};

export default DetailBox;
